import { Check, ChevronDown } from 'lucide-react';
import { Select as R } from 'radix-ui';
import { cx } from '@/lib/cx';
import s from './Select.module.css';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps {
  value: string | undefined;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  /** Visible label for assistive tech when there is no <Field>. */
  'aria-label'?: string;
  id?: string;
  size?: 'sm' | 'md';
  disabled?: boolean;
  className?: string;
  'aria-describedby'?: string;
  'aria-invalid'?: boolean;
}

/** Single choice from a short list (Radix Select). Values must be non-empty strings. */
export function Select({ value, onChange, options, placeholder, size = 'md', disabled, className, id, ...aria }: SelectProps) {
  return (
    <R.Root value={value || undefined} onValueChange={onChange} disabled={disabled}>
      <R.Trigger id={id} className={cx(s.trigger, s[size], className)} {...aria}>
        <R.Value placeholder={placeholder} />
        <R.Icon className={s.chevron}>
          <ChevronDown aria-hidden />
        </R.Icon>
      </R.Trigger>
      <R.Portal>
        <R.Content className={s.content} position="popper" sideOffset={4} collisionPadding={8}>
          <R.Viewport className={s.viewport}>
            {options.map((o) => (
              <R.Item key={o.value} value={o.value} disabled={o.disabled} className={s.item}>
                <R.ItemText>{o.label}</R.ItemText>
                <R.ItemIndicator className={s.indicator}>
                  <Check aria-hidden />
                </R.ItemIndicator>
              </R.Item>
            ))}
          </R.Viewport>
        </R.Content>
      </R.Portal>
    </R.Root>
  );
}
